import { useLocation } from "@reach/router";
import * as React from "react";
import { useFrameHooks } from "@xingternal/hub";
const ScrollManager = () => {
  const [previousPath, setPreviousPath] = React.useState("");
  const location = useLocation();
  const { useMemoizedPos } = useFrameHooks();
  const getMemoizedPos = useMemoizedPos();
  React.useEffect(() => {
    if (location.pathname !== previousPath) {
      setPreviousPath(location.pathname);
      const pos = getMemoizedPos(location.pathname);
      window.scrollTo(0, pos || 0);
    }
  }, [location, getMemoizedPos, previousPath, setPreviousPath]);
  return null;
};
export {
  ScrollManager
};
